import React, { FC, useEffect } from "react";
import { State } from "../../../redux/slices";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  Alert,
  Box,
  Button,
  FormControlLabel,
  Switch,
  TextField,
} from "@mui/material";

import { ThunkDispatch } from "@reduxjs/toolkit";
import {
  CreateLocationStep,
  CreateNewSite,
  CreateNewSiteSetValues,
  initialState,
  setCreateLocationStep,
} from "../../../redux/slices/location/createLocation";

import { FluxStandardAction } from "flux-standard-action";
import { coordinatesGeocoder } from "../../map/mapEditCreateDeleteLocations/MapEditCreateLocationSideBar";
import MapboxGeocoder, { Result } from "@mapbox/mapbox-gl-geocoder";
import mapboxgl from "mapbox-gl";

import {
  fetchLocationMapboxCoordinates,
  fetchLocations,
} from "../../../redux/actions/locations/locationsAsyncActions";

import { createLocationForGrainTracker } from "../../../redux/actions/GrainWise/grainTracker";

import { useNavigate } from "react-router-dom";
import {
  isLatitudeVerify,
  isLongitudeVerify,
} from "../editLocation/EditLocationForm";

import { setIsCreatinWithGraintracker } from "../../../redux/slices/grainTracker/grainTracker";
import { blah } from "../../../App";

const SetActions = () => {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();

  return {
    setCreateSiteValues: (value: CreateNewSite) => {
      dispatch(CreateNewSiteSetValues(value));
    },

    setStep: (value: CreateLocationStep) => {
      dispatch(setCreateLocationStep(value));
    },

    setSearchAddress: (longitude: number, latitude: number) => {
      dispatch(fetchLocationMapboxCoordinates({ longitude, latitude }));
    },
    setIsCreatinWithGraintracker: (isGrainTracker: boolean) => {
      dispatch(setIsCreatinWithGraintracker(isGrainTracker));
    },

    createLocationForGrainTracker: (token: string, navigate: any) => {
      dispatch(createLocationForGrainTracker({ token, navigate }));
    },

    locationsInit: (token: string) => {
      dispatch(fetchLocations(token));
    },
  };
};

export const StepTwoOptionB: FC<any> = () => {
  const [t] = useTranslation("global");
  const navigate = useNavigate();
  const { createNewSite, error } = useSelector(
    (state: State) => state.CreateLocationReducer
  );
  const { isCreatingWithGrainTracker } = useSelector(
    (state: State) => state.GrainWiseReducer
  );

  const { locations } = useSelector((state: State) => state.LocationsReducer);
  const { user } = useSelector((state: State) => state.Authentication);
  const { identifier, latitude, longitude, siteName } = createNewSite;

  const token = user?.token ?? "";

  const {
    setCreateSiteValues,
    setSearchAddress,
    setIsCreatinWithGraintracker,
    createLocationForGrainTracker,
    locationsInit,
  } = SetActions();

  useEffect(() => {
    locations.length === 0 ? locationsInit(token) : blah();
  }, []);

  const geocoder = new MapboxGeocoder({
    accessToken: process.env.REACT_APP_MAPBOX_TOKEN as string,
    localGeocoder: coordinatesGeocoder as unknown as (
      query: string
    ) => Result[],
    zoom: 4,
    placeholder: t(`Create_site.stepone.search`),
    mapboxgl: mapboxgl as any,
    reverseGeocode: true,
  });

  React.useEffect(() => {
    geocoder.addTo("#geocoder");
    const results = document.getElementById("result") as any;
    let searchResult = results?.innerText as void | FluxStandardAction<
      string,
      any,
      undefined
    >;

    geocoder.on("result", (e: any) => {
      searchResult =
        e.result.geometry.coordinates[1] < -90 ||
        e.result.geometry.coordinates[1] > 90
          ? console.log(e)
          : setSearchAddress(
              e.result.geometry.coordinates[0],
              e.result.geometry.coordinates[1]
            );

      geocoder.on("clear", () => {
        setCreateSiteValues({
          ...createNewSite,
          siteAddress: initialState.createNewSite.siteAddress,
          countryName: initialState.createNewSite.countryName,
          longitude: initialState.createNewSite.longitude,
          latitude: initialState.createNewSite.latitude,
        });
      });
    });
  }, []);

  const existingLocations = locations.map((locations) => locations.name);

  const theLocationExistValidator = (locationName: string) => {
    const normalizedInputName = locationName
      .trim()
      .toLowerCase()
      .replace(/\s+/g, "");

    return existingLocations.filter((existingName) => {
      const normalizedExistingName = existingName
        .trim()
        .toLowerCase()
        .replace(/\s+/g, "");
      return normalizedInputName === normalizedExistingName;
    });
  };

  const encounterErrorLatitude = isLatitudeVerify(latitude);
  const encounterErrorLongitude = isLongitudeVerify(longitude);

  const showingLocationExistError = () => {
    if (theLocationExistValidator(siteName).length >= 1) {
      return (
        <Alert severity="error">
          {t("Create_multi_location.csv_validator.used_location")}
        </Alert>
      );
    } else {
      return "";
    }
  };

  const showingWarningValidator = () => {
    if (!encounterErrorLatitude) {
      return (
        <Alert severity="info">
          {t("Create_multi_location.step_two.latitude_validation")}
        </Alert>
      );
    }
    if (!encounterErrorLongitude) {
      return (
        <Alert severity="info">
          {t("Create_multi_location.step_two.longitude_validation")}
        </Alert>
      );
    }
    if (!encounterErrorLatitude && !encounterErrorLongitude) {
      return (
        <Alert severity="info">
          {`${t("Create_multi_location.step_two.longitude_validation")}, """${t(
            "Create_multi_location.step_two.latitude_validation"
          )} `}
        </Alert>
      );
    } else {
      return "";
    }
  };

  return (
    <div className="steps-container-create-loc">
      <div className="step-title">{t("Create_site.stepone.step")}</div>
      <div>
        <div className="step-title-create">
          {t("Create_site.stepone.create_title")}
        </div>
        <div>{showingLocationExistError()}</div>
        <div>{showingWarningValidator()}</div>
        <div className="create-site-form" style={{ background: "#fff" }}>
          <Box
            component="form"
            sx={{ "& > :not(style)": { m: 1 } }}
            noValidate
            autoComplete="off"
          >
            <div className="input-create-loc-form">
              <TextField
                inputProps={{ style: { height: "31.5px" } }}
                fullWidth
                InputLabelProps={{ shrink: true }}
                label={t("Create_site.stepone.site_name")}
                value={siteName}
                variant="outlined"
                onChange={(e) =>
                  setCreateSiteValues({
                    ...createNewSite,
                    siteName: e.currentTarget.value,
                  })
                }
              />
            </div>

            <div className="container-address-form">
              <div className="container-address-input">
                <label className="form-label-input-address">
                  {t("Create_site.stepone.site_address")}
                </label>
                <div id="geocoder" />
              </div>
              <span className="or-span-create-loc">
                {t("Create_site.stepone.or")}
              </span>
              <TextField
                InputLabelProps={{ shrink: true }}
                type="number"
                inputProps={{
                  style: { height: "31.5px" },
                  inputMode: "numeric",
                }}
                error={!!error}
                sx={{
                  marginTop: "-10.5px",
                  width: 150,
                  maxWidth: "calc(100% - 20px)",
                }}
                onChange={(e) =>
                  setCreateSiteValues({
                    ...createNewSite,
                    latitude: e.currentTarget.value as unknown as number,
                  })
                }
                value={latitude}
                label={t("Create_site.stepone.latitude")}
                variant="outlined"
              />
              -
              <TextField
                InputLabelProps={{ shrink: true }}
                sx={{
                  marginTop: "-10.5px",
                  width: 150,
                  maxWidth: "calc(100% - 20px)",
                  marginRight: "24px",
                }}
                onChange={(e) =>
                  setCreateSiteValues({
                    ...createNewSite,
                    longitude: e.currentTarget.value as unknown as number,
                  })
                }
                inputProps={{
                  style: { height: "31.5px" },
                  inputMode: "numeric",
                }}
                error={!!error}
                value={longitude}
                label={t("Create_site.stepone.longitude")}
                variant="outlined"
                type="number"
              />
              {error ? (
                <div className="error-find-location-create-location">
                  {error}
                </div>
              ) : (
                ""
              )}
            </div>

            <div className="create-site-form-2">
              {/* //For now disable */}
              {/* {AutoCompleteGroupsCreateLocations(t)} */}

              <TextField
                InputLabelProps={{ shrink: true }}
                sx={{
                  width: 406,
                  maxWidth: "calc(100% - 20px)",
                }}
                disabled
                inputProps={{ style: { height: "31.5px" } }}
                value={identifier}
                onChange={(e) =>
                  setCreateSiteValues({
                    ...createNewSite,
                    identifier: e.currentTarget.value,
                  })
                }
                label={t("Create_site.stepone.identifier")}
                variant="outlined"
              />
            </div>
          </Box>
        </div>
        <div className="create-site-form mt-3" style={{ background: "#fff" }}>
          <div>
            <FormControlLabel
              control={
                <Switch
                  onChange={() =>
                    isCreatingWithGrainTracker
                      ? setIsCreatinWithGraintracker(false)
                      : setIsCreatinWithGraintracker(true)
                  }
                  checked={isCreatingWithGrainTracker}
                />
              }
              label={t("Grain_tracker.activate_graintracker")}
            />
          </div>

          <div className="graintracker-desc-switch">
            {t("Grain_tracker.switch_desc")}
          </div>
        </div>
        <Button
          variant="contained"
          sx={{ textTransform: "none", marginTop: "24px" }}
          disabled={
            !siteName ||
            !longitude ||
            !latitude ||
            theLocationExistValidator(siteName).length >= 1 ||
            !encounterErrorLatitude ||
            !encounterErrorLongitude
          }
          onClick={() => createLocationForGrainTracker(token, navigate)}
        >
          {t("Create_site.stepone.Continue")}
        </Button>
      </div>
      <div className="background-components-fix" />
    </div>
  );
};

export default StepTwoOptionB;
